var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
        container: true,
        'variant-stacked': _vm.variant === 'stacked',
        'variant-left': _vm.variant === 'left',
        'variant-right': _vm.variant === 'right',
        primary: !_vm.secondary,
        secondary: _vm.secondary
    }},[(_vm.name)?_c('div',{staticClass:"name"},[_vm._v("\n        "+_vm._s(_vm.name)),(_vm.colon)?_c('span',[_vm._v(":")]):_vm._e()]):_vm._e(),(_vm.$slots.default)?_c('div',{staticClass:"value"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }